// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackPopover-cls1_EgL","cls2":"FeedbackPopover-cls2_i_7 FeedbackPopover-cls1_EgL"};